module.exports = __webpack_public_path__ + "img/upcoming-deliveries.252e8cdb.png";